


// import React from "react";
// import { Link } from "react-router-dom";

// const HomeWorld = ({ data }) => {
//     console.log("HomeWorld DATA:", data);

//     // If backend data missing
//     if (!data || data.length === 0) return null;

//     const worldSection = data[0];

//     // Handle multiple featured news if available (assuming featuredNews could be an array)
//     const featuredList = Array.isArray(worldSection.featuredNews) ? worldSection.featuredNews : [worldSection.featuredNews].filter(Boolean);

//     // Map worldNews to handle multiple images/data per item
//     const list = (worldSection.worldNews || []).map((item) => ({
//         titles: Array.isArray(item.title) ? item.title : [item.title || "No Title"],
//         images: Array.isArray(item.imageUrl) ? item.imageUrl : [item.imageUrl || "/assets/img/default.jpg"],
//         categories: Array.isArray(item.category) ? item.category : [item.category || "World"],
//         dates: Array.isArray(item.date) ? item.date : [item.date || "2025-11-01"],
//     }));

//     return (
//         <>
//             <section className="bg-body section-space-less30">
//                 <div className="container">
//                     <div className="ne-isotope">
//                         <div className="row">
//                             <div className="col-12">
//                                 <div className="topic-border color-azure-radiance mb-30">
//                                     <div className="topic-box-lg color-azure-radiance">
//                                         {worldSection.sectionTitle || "विश्व समाचार"}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="row">
//                             {/* LEFT SIDE - World News List */}
//                             <div className="col-xl-8 col-lg-7 col-md-7 col-sm-12">
//                                 <div className="row keep-items-4-md">
//                                     {list.map((item, index) => (
//                                         <div
//                                             className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6"
//                                             key={index}
//                                         >
//                                             <div className="mb-25 position-relative d-flex flex-column">
//                                                 {/* Handle multiple images: Display first image or all in a small grid/carousel if needed */}
//                                                 <div className="image-container mb-15" style={{ flex: 1, minHeight: "200px" }}>
//                                                     {item.images.length === 1 ? (
//                                                         <Link to="/news_info">
//                                                             <img
//                                                                 src={item.images[0]}
//                                                                 alt="news"
//                                                                 className="img-fluid w-100 h-100"
//                                                                 style={{
//                                                                     objectFit: "cover",
//                                                                     borderRadius: "6px",
//                                                                 }}
//                                                             />
//                                                         </Link>
//                                                     ) : (
//                                                         <div className="d-flex flex-wrap">
//                                                             {item.images.slice(0, 4).map((img, imgIndex) => (
//                                                                 <Link to="/news_info" key={imgIndex} className="flex-fill">
//                                                                     <img
//                                                                         src={img}
//                                                                         alt="news"
//                                                                         className="img-fluid w-100"
//                                                                         style={{
//                                                                             height: "100px",
//                                                                             objectFit: "cover",
//                                                                             borderRadius: "6px",
//                                                                             margin: "2px",
//                                                                         }}
//                                                                     />
//                                                                 </Link>
//                                                             ))}
//                                                         </div>
//                                                     )}
//                                                 </div>

//                                                 <div className="topic-box-top-xs">
//                                                     <div className="topic-box-sm color-cod-gray mb-20">
//                                                         {item.categories[0]}
//                                                     </div>
//                                                 </div>

//                                                 <div className="post-date-dark">
//                                                     <ul>
//                                                         <li>
//                                                             <span>
//                                                                 <i
//                                                                     className="fa fa-calendar"
//                                                                     style={{ color: "black" }}
//                                                                     aria-hidden="true"
//                                                                 ></i>
//                                                             </span>{" "}
//                                                             {new Date(item.dates[0]).toLocaleDateString()}
//                                                         </li>
//                                                     </ul>
//                                                 </div>

//                                                 <h3 className="title-medium-dark size-md">
//                                                     <Link to="/news_info">{item.titles[0]}</Link>
//                                                 </h3>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* RIGHT SIDE - Featured News (Handle multiple if available) */}
//                             <div className="col-xl-4 col-lg-5 col-md-5 col-sm-12">
//                                 {featuredList.map((featured, index) => (
//                                     <div key={index} className="img-overlay-70 img-scale-animate mb-30">
//                                         <img
//                                             src={featured?.imageUrl || "/assets/img/default.jpg"}
//                                             alt="featured"
//                                             className="img-fluid w-100 h-100"
//                                             style={{
//                                                 objectFit: "cover",
//                                                 borderRadius: "8px",
//                                             }}
//                                         />

//                                         <div className="topic-box-top-lg">
//                                             <div className="topic-box-sm color-cod-gray mb-20">
//                                                 {featured?.category || "World"}
//                                             </div>
//                                         </div>

//                                         <div className="mask-content-lg">
//                                             <div className="post-date-light">
//                                                 <ul>
//                                                     <li>
//                                                         <span>
//                                                             <i
//                                                                 className="fa fa-calendar"
//                                                                 style={{ color: "white" }}
//                                                                 aria-hidden="true"
//                                                             ></i>
//                                                         </span>{" "}
//                                                         {new Date(featured?.date || "2025-12-06").toLocaleDateString()}
//                                                     </li>
//                                                 </ul>
//                                             </div>

//                                             <h2 className="title-medium-light size-lg">
//                                                 <Link to="/news_info">{featured?.title || "No Title"}</Link>
//                                             </h2>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default HomeWorld;








import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const HomeWorld = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // ---------- DEFAULT STATIC DATA ----------
  const defaultData = {
    main_news: {
      featured: {
        title: "विश्व की ताज़ा खबरें",
        category:
          "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार...",
        date: "2017-03-22T17:49",
        // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp",
        image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
      },
      list: [
        {
          title:
            "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
          // image:
          //   "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
          category: "News",
          date: "2017-03-22T17:50",
          description:
            "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी...",
        },
        {
          title:
            "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
          // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है...",
        },
        {
          title:
            "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
          // image: "/assets/img/11-1_1759952360.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था...",
        },
      ],
    },
  };

  // ---------- FETCH DATA ----------
  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/world/all`
        );

        if (!mounted) return;

        const fetchedData = res?.data?.data?.[0] || defaultData;
        setData(fetchedData);
      } catch (err) {
        console.log("World fetch error:", err);
        setData(defaultData);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => (mounted = false);
  }, []);

  if (loading) return <div>Loading...</div>;

  const featured = data.main_news?.featured;
  const list = data.main_news?.list || [];

  return (
    <section className="section-space-bottom-less30 mt-lg-5">
      <div className="container">
        {/* ---------- SECTION TITLE ---------- */}
        <div className="topic-border color-cod-gray mb-30">
          <div className="topic-box-lg color-cod-gray">{featured?.title}</div>
        </div>
        {/* ---------- FEATURED WORLD NEWS ---------- */}
        <div className="featured-news-card mb-5">
          <img
            src={
              Array.isArray(featured?.image)
                ? featured.image[0]
                : featured?.image
            }
            alt="featured"
            className="featured-image"
            onError={(e) => (e.target.src = "/assets/img/placeholder.jpg")}
          />
          <div className="featured-overlay">
            <span className="cat-badge">{featured?.title}</span>
            <h1 className="featured-title">
              <Link to="/news-info">{featured?.category}</Link>
            </h1>
            <p className="featured-date" style={{ color: "white", fontSize: "16px" }}>
              <i className="fa fa-calendar" style={{ margin: "10px" }}></i>
              {new Date(featured?.date).toLocaleDateString("hi-IN")}
            </p>
            <i className="fa fa-share-alt" style={{ fontSize: "25px" }} />
            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
          </div>
        </div>
        {/* ---------- WORLD NEWS LIST ---------- */}
        <div className="row" style={{marginTop:"40px"}}>
          {list.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="news-card">
                <Link to="/news-info">
                  <img
                    src={Array.isArray(item.image) ? item.image[0] : item.image}
                    alt="news"
                    className="news-img"
                    onError={(e) =>
                      (e.target.src = "/assets/img/placeholder.jpg")
                    }
                  />
                </Link>
                <div className="news-content">
                  <span className="news-cat">{item.category}</span>

                  <h3 className="news-title">
                    <Link to="/news-info">{item.title}</Link>
                  </h3>
                  <p className="news-desc">{item.description}</p>
                  <p className="news-date" style={{ fontSize: "16px", color: "black", fontFamily: "sans-serif" }}>
                    <i className="fa fa-calendar" style={{ color: "black", fontSize: "16px" }}></i>{" "}
                    {new Date(item.date).toLocaleDateString("hi-IN")}
                  </p>
                  <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black" }} />
                  <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                  <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeWorld;


